import store from 'redux/store'
import { ApiUrl } from 'api/client'

interface Props {
  jobId: string
  onParsedLine?: (line: string) => void
  onLastLineParsed?: () => void
  signal?: AbortSignal
  onError?: (error: unknown) => void
}

export const fetchStream = async ({ jobId, onParsedLine, onLastLineParsed, signal, onError }: Props) => {
  const { headers } = store.getState()

  const streamResponse = await fetch(`${ApiUrl}/stream-generation?job_id=${jobId}`, {
    method: 'GET',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    signal,
  })
  if (!streamResponse.body || streamResponse.status !== 200) {
    onError?.(new Error('Failed to fetch stream'))
    return
  }
  const reader = streamResponse.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let done = false
  let value

  try {
    while (!done) {
      if (signal?.aborted) {
        reader.cancel()
        break
      }

      ;({ done, value } = await reader.read())

      let chunk = decoder.decode(value)
      const lines = chunk.split('\n')
      const parsedLines = lines.flatMap((line) => {
        line = line.replace(/^data: /, '')
        line = line.replace(/\\n/g, '\n')
        if (line === '' || line === '[DONE]') return null

        return line
      })

      parsedLines.forEach((line) => {
        if (!line || line === '[DONE]') return
        onParsedLine?.(line)
      })

      if (!!done) onLastLineParsed?.()
    }
  } catch (error: unknown) {
    if (error instanceof Error && error.name === 'AbortError') {
      reader.cancel()
      return
    }
    reader.cancel()
    throw error
  }
}
